<template>
  <div ref="watermark" class="cont">
    <el-breadcrumb separator="/" style="margin-bottom:21px">
      <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 12px;color: #999999 ">首页</el-breadcrumb-item>
      <el-breadcrumb-item style="font-size: 12px;color: #666666;">按DIXCEL产品编号查询</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="main-cont clear">
      <div style="margin-bottom:20px;font-size: 18px;font-weight: 700;color: #666666;display:flex;align-items:center">
        <div style="width:227px;height:51px" :style="{backgroundImage: 'url(' + imgu105 + ')' }"></div>
        <el-autocomplete  @input="handleInput"  :fetch-suggestions="querySearch"  @select="handleSelect" v-model="query" placeholder="请输入DIXCEL产品编号" style="height:51px;line-height:51px;width:400px;height:51px;margin-left:10px"></el-autocomplete>
        <div @click="search(1)" style="height:50px;width:60px;background-color:#f90000;margin-left:10px;justify-content:center;align-items:center;display:flex;cursor : pointer">
          <i class="el-icon-search" style="color:#fff;font-size:28px;"></i>
        </div>
        <div style="text-align:right;flex:1">
          <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
          <el-switch v-model="priceShow" @change="togglePriceShow"> </el-switch>
          <span style="margin-right:10px;margin-left:20px;font-size: 14px;color: #333333;">现货开关</span>
          <el-switch v-model="goodsShow" @change="toggle"> </el-switch>
        </div>
      </div>
<!--
      <div style="margin-bottom:20px;display:flex;align-items:center">
        <el-input placeholder="输入DIXCEL产品编号查询" v-model="query" class="input-with-select" style="width:600px">
          <el-button slot="append" icon="el-icon-search" @click.stop="search"></el-button>
        </el-input>
        <div style="text-align:right;flex:1">
          <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
          <el-switch
            v-model="priceShow"
          >
          </el-switch>

        </div>
      </div> -->

      <div class="item" v-for=" ( goodItem , idx ) in goods " :key='idx' @click="gotoDetail(goodItem)" style="cursor : pointer">
        <div class="num_cont">
          <el-image
            v-if="goodItem.amount == 0"
            style="width: 50px; height: 50px"
            :src="u189"
            fit="contain">
          </el-image>
          <el-image
            v-if="goodItem.amount <= moduleUser.goods_num && goodItem.amount > 0"
            style="width: 50px; height: 50px"
            :src=" publicUrl + '/profile/avatar/u188.png' "
            fit="contain">
          </el-image>
          <el-image
            v-if="goodItem.amount > moduleUser.goods_num"
            style="width: 50px; height: 50px"
            :src=" publicUrl + '/profile/avatar/u187.png' "
            fit="contain">
          </el-image>
        </div>
        <div>
          <el-image
            style="width: 200px; height: 200px;margin-top:16px;margin-bottom:10px"
            class="product_image"
            :src=' publicUrl + goodItem.apiGoodsSpec.goodsPic '
            fit="contain"
          ></el-image>
        </div>
        <div class="line line1" style="min-height: 30px">
          <el-image v-if="goodItem.promotionStatus ==1"
                    style="width: 100px; height: 25px" :src=" publicUrl + '/profile/avatar/cxz.png' " fit="contain">
          </el-image>
        </div>

        <div class="line line1" v-if="moduleUser.goods_visible == '1' ">{{ goodItem.goodsName }}
          <span v-if="goodItem.apiGoodsSpec.salesUnit" style="color: red">({{goodItem.apiGoodsSpec.salesUnit}})</span>
        </div>
        <div class="line line1" v-else-if="moduleUser.goods_visible == '0' ">{{ goodItem.goodsErp.specification }}</div>

        <div class="line line2" style="min-height: 64px">
          <span  class="ql-editor" v-html="goodItem.description ? goodItem.description : ''"></span>
        </div>
        <div class='line line2'  @click.stop="goodsStockDetail(goodItem)" style="color: red">查看库存详情>></div>
        <div class='line line3'>
          <div style="color: #7F7F7F;">
            <div>零售价</div>
            <div> ¥ {{ goodItem.apiGoodsSpec.goodsPrice }}</div>
          </div>
          <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
            <div style="text-decoration: line-through;">拿货价</div>
            <div style="text-decoration: line-through;"> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
          </div>
          <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus ==1">
            <div>活动价</div>
            <div> ¥ {{goodItem.promotionPrice }}</div>
          </div>
          <div style="color: #E60012;" v-show="priceShow&&goodItem.promotionStatus !=1">
            <div>拿货价</div>
            <div> ¥ {{goodItem.apiGoodsSpec.discountPrice }}</div>
          </div>
        </div>
        <div style="display:flex">
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            @click.stop="gotoSettlement(goodItem)"
            style="cursor : pointer"
          >
            立即购买
          </div>
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            @click.stop="addCartItem(goodItem)"
            style="cursor : pointer"
          >
            加入购物车
          </div>
        </div>
      </div>
    </div>

    <div style="text-align:center;background-color:#fff;padding:44px 0 38px" class='pagination'>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size ='pageSize'
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        prev-text=' 上一页 '
        next-text=' 下一页 '>
      </el-pagination>
    </div>


    <el-dialog title="" :visible.sync="showFlag" width="650px" center  :show-close='false'
               :close-on-press-escape='false' :close-on-click-modal ='false' >
      <div style="width:100%;margin-bottom:10px;text-align: center">
        <div style="text-align: center;font-size: 20px;font-weight: bold;margin-bottom: 60px">{{goodsName}}</div>
        <div style="margin-bottom: 100px">
          <div v-for=" ( detail , idx ) in stockDetail " :key='idx' style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div  class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              <div v-if='detail.showFlag == "0"'>
                {{detail.subWarehouseName}}:
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else-if='detail.quantity <= moduleUser.goods_num && detail.quantity > 0' >少量现货</span>
                <span v-else-if= 'detail.quantity == 0'  >可以预定</span>
              </div>
              <div v-else-if='detail.showFlag == "1"'>
                {{detail.subWarehouseName}} :
                <span  v-if='detail.quantity > moduleUser.goods_num'>现货充足</span>
                <span  v-else>{{  detail.quantity }}</span>
              </div>
            </div>
          </div>
          <div   style="text-align: center;  width: 100%;   margin-left: 33%;margin-bottom: 20px">
            <div   class="background_style btn"  :style="{backgroundImage: 'url(' + u35 + ')' }" style="text-align: center;width: 200px" >
              在途数 :{{transitQuantity}}
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"  :style="{backgroundImage: 'url(' + btn_red + ')' }"
             style="cursor : pointer"  @click="stockDetailCancel" >
          关闭
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getGoodsListByQuery , addCartItemReq , getTextListReq,getStockDetail } from "@/api/productList/productList";
import watermark from '@/utils/waterMark'
export default {
  comments:watermark,
  data(){
    return{

      priceShow : true ,
      showFlag : false ,
      stockDetail:[],
      transitQuantity:0,
      goodsName:'',
      goodsShow : false ,
      searchValue : '' ,
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      u35 : this.common.publicUrl + '/profile/avatar/u35.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      imgu105 :  this.common.publicUrl + '/profile/avatar/u105.png' ,
      imgu106 :  this.common.publicUrl + '/profile/avatar/u106.png' ,
      u189 :  this.common.publicUrl + ( this.$store.state.moduleUser.discount_status=='Y'?'/profile/avatar/u189.png':'/profile/avatar/u190.png') ,
      pageNum : 1 , //当前页数
      goods : [] , //商品列表
      pageSize : 20 , //每页条数
      query : '' , //查询参数
      total : 0 ,
      searchFlag :false,
      restaurants:[]

    }
  } ,

  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
  activated(){
    console.log("watermark")
    let  dealerName =window.localStorage.dealerName
    let  username =window.localStorage.username
    let text =dealerName+username.substring(username.length-4,username.length)
    watermark.set(text,this.$refs.watermark);
    if(this.searchFlag){
      this.searchFlag = false;
    }else{
        this.query = this.$route.params.query
        this.goods = []
        this.pageNum = 1
        this.search(1)
    }
    this.restaurants = []
    this.getTextList()

    this.$nextTick(()=>{
      // console.log(window.localStorage.priceShow==0?true:false)
      this.priceShow = window.localStorage.priceShow==0?true:false;
    })

  },

  deactivated(){
    this.query = ''
  },
  created(){
    this.query = this.$route.params.query
    this.goods = []
    this.pageNum = 1
    this.search(1)
    this.getTextList()
    this.searchFlag = true;

  },
  methods : {
    handleInput(){
      // 去除所有空格
      this.query = this.query.replace(/\s+/g, '')
    },
    togglePriceShow(){
      window.localStorage["priceShow"] =this.priceShow?"0":"1";
    },
    getTextList(){
      getTextListReq({
        searchType:3 ,
      }).then( res => {
        if (res.data.status == 0) {
          let texts = res.data.texts;
          this.restaurants = []
          for(let i =0;i<texts.length;i++){
            this.restaurants.push( {"value":texts[i].text})
          }
        } else {
          this.$message.error(res.data.statusDesc);

        }
      })
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);

    },
    handleSelect(){
      this.search(1)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf("") === 0);
      };
    },

    toggle(){
      this.pageNum = 1
      this.goods = []
      this.search(0);
    },
    handleCurrentChange(){
      // console.log( this.pageNum )
      this.search(0)
    } ,
    search(searchTypeEvent){
      // let that = this
      getGoodsListByQuery({
        pageNum : this.pageNum ,
        pageSize : this.pageSize ,
        query : this.query ? this.query : '' ,
        goodsNumFlag : this.goodsShow   ,
        searchTypeEvent:searchTypeEvent
      }).then( res => {
        if (res.data.status == 0) {
          this.goods = res.data.goods ;
          this.total = res.data.total
        } else {
          this.$message.error(res.data.statusDesc);

        }
      })
    } ,
    //点击跳转详情页
    gotoDetail( goodItem ){
      let goodsId = goodItem.goodsId
      let jancode = goodItem.apiGoodsSpec.jancode
      this.$router.push({
        path: '/goodDetail',
        query: {
          goodsId: goodsId ,
          jancode : jancode,
          searchType : 3,
          searchValue : this.query,
        }
      })
      // let routeData = this.$router.resolve({
      //   path: '/goodDetail',
      //   query: {
      //     goodsId: goodsId ,
      //     jancode : jancode
      //   }
      // });
      // window.open(routeData.href, '_blank');
    } ,
    //加入购物车
    addCartItem( goodItem ){
      let curGoodsInfo = goodItem
      addCartItemReq({
        goodsId : curGoodsInfo.goodsId ,
        goodsName : curGoodsInfo.goodsName ,
        jancode : curGoodsInfo.apiGoodsSpec.jancode ,
        goodsSpecId : curGoodsInfo.apiGoodsSpec.goodsSpecId ,
        quantity : 1 ,
        goodsPic : curGoodsInfo.apiGoodsSpec.goodsPic ,
        subTitle : curGoodsInfo.subTitle? curGoodsInfo.subTitle : '' ,
        specSkuId : curGoodsInfo.apiGoodsSpec.specSkuId ,
        sukSpec  : curGoodsInfo.apiGoodsSpec.sukSpec ,
        searchValue : this.query ,
        searchType : 3 ,
        description : curGoodsInfo.description
      }).then( res => {
        if (res.data.status == 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$store.commit('cart_refresh_open');
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    // 去结算页面
    gotoSettlement( goodItem ){
      let item = goodItem
      let apiTempOrder = []
      apiTempOrder.push({
        goodsId : item.goodsId ,
        jancode : item.apiGoodsSpec.jancode ,
        searchValue : this.query ,
        quantity : 1 ,
      })
      if( apiTempOrder.length <= 0 ){
        this.$message('暂时不能购买');
        return
      }
      this.$store.commit('cart_refresh_open');
      apiTempOrder =  JSON.stringify( apiTempOrder )
      this.$router.push({
        path: '/splitOrder',
        query: {
          apiTempOrder : apiTempOrder ,
          isCartItem : 0 ,
        }
      })

    },

    // 库存详情
    goodsStockDetail( goodItem ){
      let item = goodItem
      this.goodsName =item.goodsName
      this.stockDetail= [];
      getStockDetail({
        jancode:item.apiGoodsSpec.jancode ,
      }).then( res => {
        if (res.data.status == 0) {
          this.showFlag = true;
          this.stockDetail = res.data.stockDetail;
          this.transitQuantity = res.data.transitQuantity;
        } else {
          this.$message.error(res.data.statusDesc);

        }
      })

    }
    ,stockDetailCancel(){
      this.showFlag = false;
    }
  }
}
</script>

<style lang="stylus" scoped>


.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
  padding : 20px 0
}
.cont >>>  .el-input__inner{
  height 51px;
  line-height:51px;
}
.input-with-select >>> .el-input__inner{
  border-radius: 20px 0 0 20px;
}
.input-with-select >>> .el-input-group__append{
  background-color #fff
  border-radius: 0 20px 20px 0;
}


.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.main-cont {
  background-color: #fff;
  padding 24px 65px 0;
  min-height:300px
}

.item {
  width: 230px;
  height: 480px;
  float: left;
  text-align: center;
  margin-right 50px
  margin-bottom 20px
  border: 1px solid rgb(242, 242, 242);
  box-sizing border-box;
  position relative;
  cursor : pointer
}
  .num_cont{
    position absolute;
    right:0;
    top:0;
    height:50px;
    width:50px;
    z-index : 999;
  }
  .line{
    overflow:hidden; //超出的文本隐藏
    text-overflow:ellipsis; //溢出用省略号显示
    white-space:nowrap; //溢出不换行
    padding : 0 10px ;
    box-sizing border-box
  }
  .line1{
    font-size: 12px;
    color: #333333;
    margin-bottom 7px
  }
  .line2{
    font-size: 12px;
    margin-bottom 12px;
    white-space: pre-wrap;
  }
  .line3{
    font-size: 14px;
    font-weight: 400;
    color: #F04844;
    margin-bottom 19px
    display : flex
    justify-content: space-around
  }
.item:nth-child(4n + 5) {
  margin-right 0
}
.pagination >>> .btn-prev , .pagination >>> .btn-next {
  padding : 0 10px
}
</style>
